import React from 'react';
import Breadcrumb from '../../Shared/BreadCumb';
import {BUTTON_LINE_ICON} from '../../Shared/Constants';
import ClipLoader from "react-spinners/ClipLoader";
import { getOfficials } from './services/officials';
import { newOfficial } from './services/officials';
import { getRanges } from './services/officials';
import { Link } from "react-router-dom";
import { Switch } from '@headlessui/react';
import {
MagnifyingGlassIcon, 
PlusCircleIcon, 
PencilIcon
 } from '@heroicons/react/20/solid';
import ResponsiveTable from '../../Shared/ResponsiveTable';


class OfficialsList extends React.Component {
    
    BreadcrumbPages = [
        { name: 'Administración', href: '#', current: false },
        { name: 'Lista de Funcionarios', href: '#', current: true },
    ]

    columns = [
        {field:'firstName', headerName: 'Nombre'},
        {field:'firstLastName', headerName: 'Apellido'},
        {field:'email', headerName: 'Correo'},
        {field:'identification', headerName: 'Identificación'},
        {field:'userName', headerName: 'Nombre de usuario'},
        {field:'code', headerName:'Codigo de funcionario'},
        {field:'rangeDescrip', headerName:'Rango'},
    ]

    constructor(props) {
            super(props);    
            this.state = {
                limit:0,
                dialog: false,
                enabled: false,
                loading: true,
                officials: [],
                search:'',
                ranges: [],
                username:'',
                idRange:0,
            };
    }


    componentDidMount() {
        this.loadUsers();
    }

    loadUsers() {
        getRanges({id: 0,idAdminDescrip: 4,active: true,limit:5000}).then((result) => {
            this.setState({ranges:result.data.data});
        });
        getOfficials({limit:5000})
            .then((officials) => {
                const data = officials.data.data.map((item) => {
                    item.pks = item.id;
                    return item
                });
                this.setState({loading:false, officials:data});
                this.loadTableOptions();
            }).catch(error => {
                this.setState({loading:false});
                console.log(error)
            })
    }

    loadTableOptions(){
        if(this.props.canEdit){
            this.columns.pop();
            this.columns.push({
                field: 'acciones',
                type:'actions',
                width:200,
                getActions: (params) => [
                        <button 
                            title='Actualizar informacion'
                            onClick={() => {this.openUpdate(params.row)}}
                            type="button"
                            className="rounded-full bg-gray-600 p-1 text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                        >
                            <PencilIcon 
                                style={{padding:3}}
                                aria-hidden="true" className="h-5 w-5" />
                        </button>,
                        <Link to={params.row.identification}>
                            <button 
                                title='Ver detalles'
                                type="button"
                                className="rounded-full bg-gray-600 p-1 text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">
                                <MagnifyingGlassIcon aria-hidden="true" className="h-5 w-5" />
                            </button>
                        </Link>,
                        <Switch
                            checked={params.row.active ? true : false}
                            onChange={() => {this.setActive(!params.row.active, params.row)}}
                            className="group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
                        >
                            <span className="sr-only">Use setting</span>
                            <span
                                aria-hidden="true"
                                className="pointer-events-none inline-block size-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                            />
                        </Switch>
                    ]
                })
        }
    }

    renderActions = (row) => {
        if (!this.props.canEdit) return null;
        
        return (
            <div className="flex items-center space-x-2">
                <button 
                    title='Actualizar informacion'
                    onClick={() => {this.openUpdate(row)}}
                    type="button"
                    className="rounded-full bg-gray-600 p-1 text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                >
                    <PencilIcon 
                        style={{padding:3}}
                        aria-hidden="true" className="h-5 w-5" />
                </button>
                <Link to={row.identification}>
                    <button 
                        title='Ver detalles'
                        type="button"
                        className="rounded-full bg-gray-600 p-1 text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">
                        <MagnifyingGlassIcon aria-hidden="true" className="h-5 w-5" />
                    </button>
                </Link>
                <Switch
                    checked={row.active ? true : false}
                    onChange={() => {this.setActive(!row.active, row)}}
                    className="group relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
                >
                    <span className="sr-only">Use setting</span>
                    <span
                        aria-hidden="true"
                        className="pointer-events-none inline-block size-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                    />
                </Switch>
            </div>
        );
    }

    openByDialog = () => {
        this.props.openDialog();
    }

    openUpdate = (item) => {
        this.props.openDialog(item)
    }

    searchOficcial(){
        const body = {limit:parseInt(this.state.limit)}
        if(this.state.idRange > 0) {
            body.idRange = parseInt(this.state.idRange);
        }
        if(this.state.username !== '') {
            body.userName = this.state.username;
        }
        if(this.state.search !== '') {
            body.search = this.state.search;
        }
        this.setState({loading:true});
        getOfficials(body)
            .then((oficcials =>{
                if(oficcials) {
                    const data = oficcials.data.data.map((item) => {
                        item.pks = item.id;
                        return item
                    });
                    this.setState({loading:false, officials:data})
                }else{
                    this.setState({loading:false, officials:[]})
                }
            })).catch((error) => {
                this.setState({loading:false})
                console.log(error)
            })
    }

    searchInput = () => {
        return (
            <div class="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 p-4">
                
                <div style={{marginRight:10}}>
                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                        Busqueda general
                    </label>
                    <div className="mt-2">
                        <input
                            value={this.state.search}
                            onChange={(e) => {this.setState({search:e.target.value})}}
                            id="email"
                            name="email"
                            type="text"
                            placeholder=""
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        />
                    </div>
                </div>

                <div>
                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                        Nombre de usuario
                    </label>
                    <div className="mt-2">
                        <input
                            value={this.state.username}
                            onChange={(e) => {this.setState({username:e.target.value})}}
                            id="email"
                            name="email"
                            type="text"
                            placeholder=""
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        />
                    </div>
                </div>
                <div>
                    <label htmlFor="rango" className='block text-sm/6 font-medium text-gray-900'>
                        Rango
                    </label>
                    <div className='mt-2'>
                                <select
                                    style={{maxWidth:150}}
                                    onChange={(e) => {this.setState({idRange:e.target.value})}}
                                    id="location"
                                    name="location"
                                    defaultValue={this.state.idRange}
                                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                >
                                    <option value={null}>SELECCIONAR</option>
                                    {
                                        this.state.ranges?.map((range) => {
                                            return (
                                                    <option key={range.id} value={range.id}>{range.value}</option>
                                                )
                                            })
                                    }
                                </select>

                    </div>
                </div>
                     <div>
                            <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                Limite
                            </label>
                            <div className="mt-2">
                                <select
                                    onChange={(e) => {this.setState({limit:e.target.value})}}
                                    value={this.state.limit}
                                    id="location"
                                    name="location"
                                    defaultValue="Canada"
                                    className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                    >
                                    <option value={0}>TODOS</option>
                                    <option value={10}>10</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                    <option value={500}>500</option>
                                    <option value={1000}>1000</option>
                                </select>
                            </div>
                    </div>
                <div className='relative mt-2 rounded-md shadows-sm' style={{marginLeft:10, marginTop:35}}>
                    <button
                        onClick={() => {this.searchOficcial()}}
                        type="button"
                        className="rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                    >
                        Buscar
                    </button>
                </div>
            </div>
        )
    }

    setActive(value, item){
        this.setState({loading:true})
        item.active = value;
        item.id = item.pks;
        newOfficial(item)
            .then((result) => {
                this.setState({loading:false})
                this.searchOficcial();
            }).catch(error => console.log('error', error))
    }

    renderList(){
        
        return(
            <div className="px-4 sm:px-6 lg:px-8">
                <div style={{marginBottom:10}}>
                    <Breadcrumb pages={this.BreadcrumbPages}/>
                </div>
                <div class="w-full p-4" >
                    <div class="w-full rounded overflow-hidden shadow-lg bg-white" style={{backgroundColor:'#f1f4ff'}}>
                        <div class="px-6 py-4">
                            <p class="text-gray-700 text-base" style={{fontWeight:'bold'}}>
                                En esta sección podrás crear y administrar los usuarios que podrán acceder y hacer uso exclusivo del aplicativo móvil.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-white font-semibold text-gray-900">.</h1>
                    </div>
                    <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                        {
                            this.props.canCreate ? 
                                <button
                                    onClick={() => {this.openByDialog()}}
                                    type="button"
                                    className={BUTTON_LINE_ICON}>
                                    <PlusCircleIcon aria-hidden="true" className="h-5 w-5 text-white-400"/>
                                    NUEVO FUNCIONARIO
                                </button>
                                :
                                null
                        }
                        
                    </div>
                </div>
            
                <div className="sm:flex sm:items-center">
                {this.searchInput()}
                </div>
                    <div className="mt-8 flow-root">
                        <ResponsiveTable 
                            data={this.state.officials} 
                            columns={this.columns} 
                            renderActions={(row) => this.renderActions(row)}
                        />
                    </div>

                </div>
        )
    }

    render() {
        return(
            <div>
                {
                    !this.state.loading ? 
                        this.renderList()
                    :
                    <center>
                        <ClipLoader
                            color={'gray'}
                            loading={true}
                            size={50}
                            aria-label="Loading Spinner"
                            data-testid="loader"/>
                    </center>
                }
            </div>
        )
    }
}

export default OfficialsList;